<template>
  <div>
    <page-header :actions="headerActionConfig" :page="pageHeaderConfig" />
    <div>
      <section-title
        :has-line="true"
        title="Búsqueda de Practicante e Interno"
      />
      <div class="ml-3">
        <validation-observer
          ref="searchPractitionerInternRef"
          novalidate
          tag="form"
        >
          <div class="d-md-flex align-items-center">
            <validation-provider
              v-slot="{ errors }"
              class="w-20"
              rules="required"
              vid="ssnVP"
            >
              <custom-input
                v-model="formatedSSN"
                class="mt-n2"
                :custom-error-msg="
                  !isSsnValid
                    ? 'El número de seguro social entrado no es valido.'
                    : 'Favor entrar un número de seguro social.'
                "
                :error="errors[0]"
                label="Número Seguro Social:"
                mask-type="Personalssn"
                placeholder="XXX-XX-XXXX"
                type="text"
              />
            </validation-provider>
            <action-button
              class="mt-4 ml-0 ml-md-3 ml-sm-0 w-sm-100"
              i="fas fa-search"
              text="Buscar Practicante e Interno"
              variant="success"
              @click="onSearchHandler"
            />
          </div>
        </validation-observer>
        <hr />
        <validation-observer
          v-if="showResult"
          ref="practitionerInternRef"
          novalidate
          tag="form"
        >
          <div class="row">
            <div class="col-md-4">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.firstName"
                  class="mt-n2"
                  custom-error-msg="Favor ingresar el nombre"
                  :disabled="formDisabled"
                  :error="errors[0]"
                  label="Nombre:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 mt-md-0 mt-sm-3">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="model.lastPaternalName"
                  class="mt-n2"
                  custom-error-msg="Favor ingresar el apellido paterno"
                  :disabled="formDisabled"
                  :error="errors[0]"
                  label="Apellido Paterno:"
                  type="text"
                />
              </validation-provider>
            </div>
            <div class="col-md-4 col-sm-12 mt-3 mt-md-0 mt-sm-3">
              <custom-input
                v-model="model.lastMaternalName"
                class="mt-n2"
                :disabled="formDisabled"
                label="Apellido Materno:"
                type="text"
              />
            </div>
          </div>
        </validation-observer>
      </div>
      <div v-if="showResult" class="mb-5 mt-4 information-container">
        <specialty-information-list
          v-model="model.specialties"
          :add-enabled="
            userHasPermissions('provider.practitioner.specialty.add')
          "
          :custom-error-message="specialtiesErrorMessage"
          :delete-enabled="
            userHasPermissions('provider.practitioner.specialty.delete')
          "
          :edit-enabled="
            userHasPermissions('provider.practitioner.specialty.edit')
          "
          :is-valid="specialtiesAreValid"
        />
        <validation-observer ref="documentsRef" novalidate tag="form">
          <documents :items="model.documents" :readonly="formDisabled" />
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { serialize as objectToFormData } from 'object-to-formdata';
import SectionTitle from '@/components/common/page/SectionTitle';
import alertMixin from '@/mixins/alert.mixin';
import { isSsnValid as _isSsnValid } from '@/modules/provider/api';
import {
  getPractitionerDocumentTypes as _getPractitionerDocumentTypes,
  createPractitioner as _createPractitioner,
  checkPractitionerExistance as _checkPractitionerExistance,
} from '@/modules/practitionerIntern/api';
import SpecialtyInformationList from './components/SpecialtyInformation/SpecialtyInformationList';
import Documents from './components/Documents/Index';
import { CustomInput, ActionButton } from '@/components/common';
import documentTypes from '@/utils/shared/constants/documentTypes.js';

const PRACTITIONER_INTERN_EDIT = 'PractitionerInternEdit';

export default {
  name: 'PractitionerInterInfo',
  components: {
    SectionTitle,
    CustomInput,
    ActionButton,
    SpecialtyInformationList,
    Documents,
  },
  mixins: [alertMixin],
  data: () => ({
    model: {
      practitionerId: null,
      socialSecurityNumber: null,
      firstName: null,
      lastPaternalName: null,
      lastMaternalName: null,
      isActiveFlaq: true,
      fullName: null,
      specialties: [],
      documents: [],
    },
    formatedSSN: null,
    addSpecialistInfo: null,
    isSsnValid: true,
    showResult: false,
    formDisabled: true,
    specialtiesAreValid: true,
    specialtiesErrorMessage: 'La información de especialidad es requerida',
  }),
  computed: {
    ...mapState('$_user', ['user']),
    pageHeaderConfig() {
      return {
        title: 'Practicantes e Internos',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Practicantes e Internos'],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.go(-1);
          },
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: this.saveHandler,
        },
      ];
    },
  },
  watch: {
    formatedSSN(newValue) {
      this.model.socialSecurityNumber = newValue
        ? newValue.replace(/-/gi, '')
        : null;
    },
  },
  methods: {
    async saveHandler() {
      this.specialtiesAreValid = true; //For Refresh

      const practicionerIsValid = await this.$refs.practitionerInternRef.validate();
      const documentIsValid = await this.$refs.documentsRef.validate();

      let isValid = practicionerIsValid && documentIsValid;

      if (this.model.specialties.length == 0) {
        this.specialtiesAreValid = isValid = false;
      } else {
        this.specialtiesAreValid = true;
      }

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      const params = objectToFormData(
        {
          ...this.model,
          documents: null,
        },
        {
          indices: true,
          nullsAsUndefineds: true,
        }
      );

      (this.model.documents || []).forEach((document, index) => {
        params.append(`documents[${index}].file`, document.file);
        params.append(
          `documents[${index}].documentTypeId`,
          document.documentTypeId
        );
      });
      await _createPractitioner(params)
        .then((resp) => {
          this.ShowToast(
            'Proceso Exitoso',
            'Practicante guardado exitosamente.',
            'success'
          );

          this.$router.replace({
            name: 'PractitionerInternEdit',
            params: {
              practitionerId: resp.data,
              fiscalYearId: this.currentAcademicYear().id,
            },
          });
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
        });
    },
    async onSearchHandler() {
      const isValid = await this.$refs.searchPractitionerInternRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      let isSsnValid = await _isSsnValid(this.formatedSSN);
      if (!isSsnValid.data) {
        this.isSsnValid = false;
        this.$refs.searchPractitionerInternRef.setErrors({ ssnVP: ['error'] });
        this.ShowToast('Alerta', 'Información Incorrecta', 'error');
      }

      if (isValid && this.isSsnValid) {
        await _checkPractitionerExistance(this.model.socialSecurityNumber).then(
          async (res) => {
            if (res.data != '') {
              if (
                this.user.profile.companyid != undefined &&
                res.data.companyIds.some(
                  (x) => x == this.user.profile.companyid
                )
              ) {
                this.ShowToast(
                  'Atención',
                  'Se encontró que el practicante interno ya pertenece a su corporación',
                  'warning'
                );
              }

              this.$router.replace({
                name: PRACTITIONER_INTERN_EDIT,
                params: {
                  practitionerId: res.data.practitionerId,
                  companyId:
                    this.user.profile.companyid != undefined
                      ? this.user.profile.companyid
                      : null,
                  fiscalYearId: this.currentAcademicYear().id,
                },
              });
            } else {
              await this.getDocumentTypes();
              this.showResult = true;
              this.formDisabled = false;
            }
          }
        );
      }
    },
    async addSpecialistHandler() {
      const isValid = await this.$refs.specialistInfoRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
    },
    async getDocumentTypes() {
      var { data: documentsTypes } = await _getPractitionerDocumentTypes();
      const requiredDocTypes = [documentTypes.AgreementWithTheUniversity];
      this.model.documents = documentsTypes.map((docType) => ({
        documentTypeId: docType.id,
        documentTypeName: docType.name,
        file: null,
        rules: requiredDocTypes.includes(docType.id) ? 'required' : '',
      }));
    },
  },
};
</script>
<style scoped>
.information-container {
  margin-bottom: 250px !important;
}
</style>
